var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"worktime"},[_c('el-select',{attrs:{"value":_vm.copyValue.day,"placeholder":"День недели"},on:{"change":function($event){return _vm.updateValue($event, 'day')}}},_vm._l((_vm.options),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1),_c('el-time-select',{attrs:{"placeholder":"Начало работы","value":_vm.copyValue.open,"picker-options":{
      start: '08:30',
      step: '00:15',
      end: '18:30',
    }},on:{"input":function($event){return _vm.updateValue($event, 'open')}}}),_c('el-time-select',{attrs:{"placeholder":"Окончание работы","value":_vm.copyValue.close,"picker-options":{
      start: '08:30',
      step: '00:15',
      end: '18:30',
      minTime: _vm.copyValue.open,
    }},on:{"input":function($event){return _vm.updateValue($event, 'close')}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }